var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      key: "close",
      class: _vm.classes,
      attrs: { viewBox: "0 0 30 30", width: "24", fill: "currentColor" },
    },
    [
      _c("use", {
        attrs: {
          "xlink:href": "#icon-close",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }